<template>
  <!--
   در تغییرات روز 22/05/1401 تصمیم بر این شد که از
  option_value
  در کد استفاده نشود و به جای آن از
  option_number
  استفاده شود.
 -->
  <div class="overflow-hidden">
    <div class="loading-center" v-if="isLoading">
      <executeLoading />
    </div>
    <b-row
      v-if="!is_show_as_form"
      class="fixed-header w-100 mx-0 bg-white border-bottom p-3"
    >
      <b-col cols="12" md="12">
        <b-row>
          <b-col cols="12" md="6" class="text-left">
            <mdicon name="format-list-checks" class="mr-2" />
            <strong v-text="exam_pack.exam_pack_name" />
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="text-md-right text-left"
            v-if="currentTime && endTime && !currentExamPackEndedTime"
          >
            <mdicon name="timer-sand" spin class="mr-2" />
            <span v-text="'مدت زمان باقیمانده: '" /><strong v-text="counter" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-container class="mt-5">
      <b-row v-if="!isLoading && Object.keys(azmoon_execute_person).length">
        <b-col cols="12" md="12">
          <b-row v-if="!currentExamPackEndedTime">
            <b-col v-if="!is_show_as_form" cols="12" md="12">
              <b-row
                class="my-3 w-100 text-center"
                v-if="
                  Object.keys(azmoon_execute_person).length > 0 && page == 1
                "
              >
                <b-col>
                  <ul class="ul-exam">
                    <li>
                      <b>{{ $lang.azmoonLang.person_exam }} </b>:
                      {{ azmoon_execute_person.person.name }}
                    </li>
                    <li
                      v-if="
                        azmoon_execute_person.operator.name !==
                        azmoon_execute_person.person.name
                      "
                    >
                      <b>{{ $lang.azmoonLang.exam_operator }}</b> :
                      {{ azmoon_execute_person.operator.name }}
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="is_repeat_description" cols="12" md="12">
              <p v-html="createPureDom(exam_pack.exam_pack_description)" />
            </b-col>
            <b-col
              v-if="!is_show_as_form && has_questions && count_question"
              cols="12"
              md="12"
              class="text-center mt-5 mb-1 d-flex justify-content-center"
            >
              <h5 class="count_question">
                <span>
                  در این بخش از {{ currentExamPackTotalQuestions }} سوال
                  <span class="color-answer"> {{ answer_question }} </span> سوال
                  پاسخ داده شده
                </span>
                <span
                  v-if="total_question_count !== currentExamPackTotalQuestions"
                >
                  {{ $lang.and_in_total }}
                  <span class="color-answer">
                    {{ total_answer_count }}
                  </span>
                  {{
                    $lang.question_answered_of.replace(
                      "{0}",
                      total_question_count
                    )
                  }}
                </span>
              </h5>
            </b-col>
            <b-col cols="12" md="12">
              <LoadingSpinner :loading="isloadingPage" />
            </b-col>
            <b-col v-if="!isloadingPage" cols="12" md="12" class="my-1">
              <div v-for="(item, key) in question_items" :key="key">
                <b-overlay :show="item && item.loader" rounded="sm">
                  <b-card
                    v-if="
                      ((exam_pack.display_mode && exam_pack.display_mode.id) ||
                        (item.display_mode && item.display_mode.id)) == 1 &&
                      item.question_kind &&
                      item.question_kind.id !== 2 &&
                      item.question_kind &&
                      item.question_kind.id !== 3
                    "
                    class="card card-question_black my-1"
                  >
                    <div slot="header">
                      <h6
                        class="d-flex m-0"
                        v-if="exam_pack.hidden_question_title == 0"
                      >
                        <span key="fa-check"> {{ item.question_order }})</span>
                        <div
                          class="title_description mx-1 pr-4"
                          v-html="titleQuestion(item)"
                        ></div>
                        <span
                          v-if="item.is_answered"
                          class="checkAnswer text-success"
                        >
                          <mdicon name="check-circle" size="24" />
                        </span>
                      </h6>
                    </div>

                    <div
                      :class="{
                        row:
                          includes(
                            pathOr(null, ['display_style', 'id'], exam_pack),
                            [1, 3]
                          ) ||
                          includes(
                            pathOr(null, ['display_style', 'id'], item),
                            [1, 3]
                          ),
                      }"
                    >
                      <optionchecked
                        :item="item"
                        v-for="(option, index) in item.options"
                        :key="index"
                        :option="option"
                        :col_number="
                          pathOr(null, ['display_count'], exam_pack) ||
                          pathOr(null, ['display_count'], item) ||
                          2
                        "
                        :question_kind="
                          item.question_kind && item.question_kind.id
                        "
                        :option_show_kind="
                          pathOr(null, ['option_show_kind', 'id'], exam_pack) ||
                          pathOr(null, ['option_show_kind', 'id'], item)
                        "
                        :display_style="
                          pathOr(null, ['display_style', 'id'], exam_pack) ||
                          pathOr(null, ['display_style', 'id'], item)
                        "
                        :itemId="item.id"
                        @optionChecked="answerQuestioncheckbox"
                        ref="questionRef"
                      />
                      <b-col
                        cols="12"
                        class="p-1"
                        v-if="
                          pathOr(false, ['question_kind', 'id'], item) === 4 &&
                          pathOr(false, ['answer_value'], item) &&
                          !pathOr(false, ['loader'], item)
                        "
                      >
                        <b-form-textarea
                          v-model="item.answer_description"
                          @input.native="changeStatusBtn($event, item)"
                        >
                        </b-form-textarea>
                      </b-col>
                      <b-col
                        class="mt-2 text-right"
                        cols="12"
                        v-if="
                          pathOr(false, ['question_kind', 'id'], item) === 4
                        "
                      >
                        <b-button
                          v-if="item.answer_value && item.typing"
                          :variant="item.typing ? `warning` : `success`"
                          @click="answerQuestionTextarea(item)"
                          :disabled="item.loader"
                        >
                          <div v-show="!item.loader">
                            <div v-if="item.typing">
                              {{ $lang.azmoonLang.un_submitted_changes }}
                            </div>
                            <div v-if="!item.typing">
                              {{ $lang.azmoonLang.submitButton }}
                              <span
                                key="fa-check"
                                v-if="
                                  !item.typing &&
                                  (item.answer_value || item.answer_description)
                                "
                                ><i class="fa fa-check"></i
                              ></span>
                            </div>
                          </div>
                          <div v-show="item.loader">
                            <b-spinner small></b-spinner>
                            {{ $lang.azmoonLang.textLoding }}
                          </div>
                        </b-button>
                      </b-col>
                    </div>
                  </b-card>

                  <!--
                    display_mode => حالت نمایش
                    1 => کادری
                    2 => خطی
                    question_kind => نوع سوال
                    1 => گزینه ای
                    2 => عددی
                    3 => تشریحی
                    4 => گزینه ای - تشریحی
                   -->

                  <!-- لیست گزینه ها به صورت افقی -->
                  <lineOption
                    v-if="checkLineOption(item, exam_pack)"
                    :hiddenQuestionTitle="
                      exam_pack && exam_pack.hidden_question_title
                    "
                    :title="pathOr('', ['title', 'title_description'], item)"
                    :item="item"
                    :id="item.id"
                    :options="item.options"
                    :questionOrder="item.question_order"
                    :option_show_kind="
                      pathOr(false, ['option_show_kind', 'id'], exam_pack) ||
                      pathOr(false, ['option_show_kind', 'id'], item)
                    "
                    :answer_value="item.answer_value"
                    @answeQuestion="answerQuestioncheckbox"
                    :option_description="item.option_description"
                  />
                  <b-card
                    v-if="
                      includes(
                        pathOr(false, ['question_kind', 'id'], item),
                        [2, 3]
                      )
                    "
                  >
                    <div slot="header">
                      <h6
                        class="d-flex m-0"
                        v-if="exam_pack.hidden_question_title == 0"
                      >
                        <span> {{ item.question_order }})</span>
                        <div
                          class="title_description mx-1"
                          v-html="titleQuestion(item)"
                        ></div>
                      </h6>
                    </div>
                    <div>
                      <span
                        v-if="item.is_answered"
                        class="checkAnswer text-success"
                      >
                        <mdicon name="check-circle" size="24" />
                      </span>
                      <b-form-input
                        v-if="
                          pathOr(false, ['question_kind', 'id'], item) === 2
                        "
                        v-model="item.answer_value"
                        @input="changeStatusBtn($event, item)"
                        :formatter="formatter"
                        autocomplete="off"
                      ></b-form-input>

                      <b-form-textarea
                        v-if="
                          pathOr(false, ['question_kind', 'id'], item) === 3
                        "
                        autocomplete="off"
                        v-model="item.answer_description"
                        @input.native="changeStatusBtn($event, item)"
                      >
                      </b-form-textarea>
                      <div class="float-right my-2">
                        <b-button
                          v-if="
                            pathOr(null, ['question_kind', 'id'], item) === 2 &&
                            item.typing
                          "
                          :variant="item.typing ? `warning` : `success`"
                          @click="answerQuestionInput(item)"
                          :disabled="item.loader"
                        >
                          <div v-show="!item.loader">
                            <div v-if="item.typing">
                              {{ $lang.azmoonLang.un_submitted_changes }}
                            </div>
                            <div v-if="!item.typing">
                              {{ $lang.azmoonLang.submitButton }}
                              <span
                                key="fa-check"
                                v-if="
                                  !item.typing &&
                                  (item.answer_value || item.answer_description)
                                "
                                ><i class="fa fa-check"></i
                              ></span>
                            </div>
                          </div>
                          <div v-show="item.loader">
                            <b-spinner small></b-spinner>
                            {{ $lang.azmoonLang.textLoding }}
                          </div>
                        </b-button>

                        <b-button
                          v-if="
                            pathOr(null, ['question_kind', 'id'], item) === 3 &&
                            item.typing
                          "
                          :variant="item.typing ? `warning` : `success`"
                          @click="answerQuestionTextarea(item)"
                          :disabled="item.loader"
                        >
                          <div v-show="!item.loader">
                            <div v-if="item.typing">
                              {{ $lang.azmoonLang.un_submitted_changes }}
                            </div>
                            <div v-if="!item.typing">
                              {{ $lang.azmoonLang.submitButton }}
                              <span
                                key="fa-check"
                                v-if="
                                  !item.typing &&
                                  (item.answer_value || item.answer_description)
                                "
                                ><i class="fa fa-check"></i
                              ></span>
                            </div>
                          </div>
                          <div v-show="item.loader">
                            <b-spinner small></b-spinner>
                            {{ $lang.azmoonLang.textLoding }}
                          </div>
                        </b-button>
                      </div>
                    </div>
                  </b-card>
                </b-overlay>
              </div>

              <div
                class="text-center my-5"
                v-if="next == null && page == currentExamPackTotalPages"
              >
                <h4>پایان</h4>
                <p v-html="acceptEndTestText" />
                <b-button
                  @click="endAzmoon"
                  class="text-center"
                  variant="success"
                  :disabled="isBtnLoading || isbtnEnd"
                >
                  <div v-if="!isBtnLoading">
                    <mdicon name="check" size="20" />
                    {{
                      isbtnEnd
                        ? $lang.azmoonLang.close_page_exam_accept
                        : $lang.azmoonLang.close_page_exam
                    }}
                  </div>
                  <div v-if="isBtnLoading">
                    <b-spinner small></b-spinner>
                    <span> {{ $lang.azmoonLang.search.loading_send }}</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="currentExamPackEndedTime" cols="12" md="12">
          <div
            class="d-flex align-items-center justify-content-center flex-column w-100 mt-5"
          >
            <b-alert show variant="danger">
              <mdicon name="help-circle-outline" size="24" class="mr-1" />
              <b v-html="endTestTextAlert" />
            </b-alert>
            <b-alert :show="next" variant="info">
              <div class="d-flex align-items-center justify-content-between">
                <mdicon name="help-circle-outline" size="24" class="mr-1" />
                {{ endTestTextNextAlert }}
              </div>
            </b-alert>

            <div v-if="!next" class="text-center my-5">
              <h4>پایان</h4>
              <p v-html="acceptEndTestText" />
              <b-button
                @click="endAzmoon"
                class="text-center"
                variant="success"
                :disabled="isBtnLoading || isbtnEnd"
              >
                <div v-if="!isBtnLoading">
                  <mdicon name="check" size="20" />
                  {{
                    isbtnEnd
                      ? $lang.azmoonLang.close_page_exam_accept
                      : $lang.azmoonLang.close_page_exam
                  }}
                </div>
                <div v-if="isBtnLoading">
                  <b-spinner small></b-spinner>
                  <span> {{ $lang.azmoonLang.search.loading_send }}</span>
                </div>
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col v-if="!isloadingPage" cols="12" md="12" class="mb-5">
          <b-button
            @click="prevPage()"
            v-if="prev || page > 1"
            class="btn btn-primary float-left"
          >
            <mdicon name="chevron-double-right" size="20" />
            {{ $lang.azmoonLang.paginate.prev }}
          </b-button>
          <!--
            کلید
                  next
                مفهوم پرسشنامه بعدی را می دهد
                امکان دارد پرسشنامه ای دارای چند صفحه باشد
                برای رفتن به صفحات بعدی همین پرسشنامه باید از اختلاف بین صفحه جاری و همه ی صفحات استفاده شود
                (page != currentExamPackTotalPages)
                 -->
          <b-button
            @click="nextPage()"
            v-if="
              next ||
              (!currentExamPackEndedTime && page !== currentExamPackTotalPages)
            "
            class="btn btn-primary float-right"
          >
            {{ $lang.azmoonLang.paginate.next }}
            <mdicon name="chevron-double-left" size="20" />
          </b-button>
          <div
            v-if="
              has_questions && currentExamPackTotalPages !== 1 && count_question
            "
            class="pt-2 m-auto text-center"
          >
            {{ $lang.azmoonLang.page }}
            {{ page }}
            {{ $lang.azmoonLang.from }}
            {{ currentExamPackTotalPages }}
          </div>
        </b-col>
      </b-row>
      <div
        v-if="!isLoading && !Object.keys(azmoon_execute_person).length"
        class="text-center w-100 messageNot"
      >
        <div>
          <h1>شما به این بخش دسترسی ندارید</h1>
          <br /><br />
          <router-link class="btn btn-info" :to="'/dashboard'">
            صفحه اصلی
          </router-link>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import optionchecked from "./../preview/optionchecked";
import lineOption from "./../preview/lineOption";
import executeLoading from "./executeLoading";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";
import { createPureDom, toastAlert } from "@/shared/utils";
import {
  generateApiUrl,
  goToRoute,
  getCurrentQueryString,
} from "@/shared/utils";

export default {
  name: "execute-page",
  inject: ["azmoonExecuteExamPackQuestionsRepository", "personStateRepository"],
  components: {
    optionchecked,
    lineOption,
    executeLoading,
    LoadingSpinner,
  },
  data() {
    return {
      isBtnLoading: false,
      show: false,
      answer_question: 0,
      azmoon_execute_id: this.$route.params.id,
      exam_pack_id: this.$route.params.exam_pack_id,
      exam_pack: {},
      has_questions: false,
      question_items: [],
      next: null,
      prev: null,
      currentExamPackTotalQuestions: 0,
      per_page: 0,
      currentExamPackTotalPages: 1,
      page: 1,
      question_params: {},
      options: [],
      pageHistory: null,
      isOverlay: false,
      isLoading: false,
      isQuestionLoading: false,
      count_question: 0,
      answeredAllQuestions: false,
      is_repeat_description: true,
      isloadingPage: false,
      term_state_code: null,
      azmoon_execute_person: {},
      isbtnEnd: false,
      callback_url: null,
      timerQueue: null,
      timerQueue2: null,
      counter: "00:00:00",
      counter2: 10,
      currentTime: null,
      endTime: null,
      currentExamPackEndedTime: false,
      pageName: `page${this.$route.params.exam_pack_id}`,
      total_answer_count: 0,
      total_question_count: 0,
      is_show_as_form: 0,
      finishedConfirm: false,
    };
  },
  computed: {
    acceptEndTestText() {
      return ` با فشردن دکمه
            <span class="text-danger font-weigth-blod"> تایید پایان</span>
            پایان کار خود را اعلام نمایید در صورت بسته نشدن صفحه آن را بسته و ادامه فعالیت‌های خود را انجام دهید`;
    },
    endTestTextAlert() {
      return "کاربر گرامی با توجه به اتمام زمان شما در این بخش، امکان مشاهده و پاسخ به سوال‌ها وجود ندارد";
    },
    endTestTextNextAlert() {
      return `لطفا به بخش بعدی رفته و به سوالات آن بخش پاسخ دهید (انتقال خودکار به صفحه بعدی ${this.counter2})`;
    },
    isDisabledNextButton() {
      // در صورتی که پرسشنامه زمان دار باشد و زمان آن پایان نیافته باشد چک میکنیم که به همه ی سوالات جواب داده یا نه در عیر اینصورت شرط صدق نمی کند و نیازی به نمایش پیغام نیست.
      const checkAnsweredAllQuestions = !this.currentExamPackEndedTime
        ? !this.answeredAllQuestions
        : false;
      return (
        this.has_questions &&
        checkAnsweredAllQuestions &&
        this.page === this.currentExamPackTotalPages
      );
    },
  },
  watch: {
    question_items: {
      handler(items) {
        for (let item of items) {
          this.generateActiveClass(item);
        }
      },
      deep: true,
    },
    $route() {
      this.fetchData();
    },
    currentExamPackEndedTime: {
      immediate: true,
      handler(value) {
        if (value) {
          this.timer2();
        }
      },
    },
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    localStorage.removeItem("answer_question");
  },
  methods: {
    createPureDom,
    pathOr,
    includes,
    generateApiUrl,
    goToRoute,
    async endAzmoon() {
      try {
        this.isBtnLoading = true;
        const url = generateApiUrl(
          ["azmoon", "exam_pack_control_finish"],
          [this.azmoon_execute_id, this.exam_pack_id]
        );
        const { data } = await this.$httpService.patch(url);
        const message = pathOr("", ["message"], data);
        toastAlert(message);
        localStorage.removeItem(this.pageName);
        this.isbtnEnd = true;
        this.goToBackUrl();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isBtnLoading = false;
      }
    },
    formatter(value) {
      let regx = /^-?\d*[.,]?\d{0,2}$/.test(value);
      if (regx) {
        return value;
      } else {
        return ``;
      }
    },
    changeStatusBtn(event, item) {
      // if(event.target.value.length >=0){
      item.typing = true;
      // }
    },
    titleQuestion(item) {
      return ` ${
        item && item.title
          ? this.createPureDom(item.title.title_description)
          : ` `
      } `;
    },
    async answePatch(itemId, payload, item) {
      try {
        item.loader = true;
        const code = pathOr(null, ["code"], item);
        const url = generateApiUrl(
          ["azmoon", "azmoon_execute_answer"],
          [this.azmoon_execute_id, code]
        );
        const response_questions = await this.$httpService.patch(url, payload);

        // تعداد جواب های پرسشنامه جاری
        this.answer_question = pathOr(
          0,
          ["data", "data", "exam_pack_answer_count"],
          response_questions
        );
        // تعداد جواب های کل آزمون
        this.total_answer_count = pathOr(
          0,
          ["data", "data", "exam_pack_total_answer_count"],
          response_questions
        );
        item.is_answered = pathOr(
          0,
          ["data", "data", "is_answered"],
          response_questions
        );
        if (response_questions.data.state) {
          if (payload.selected == 1) {
            if (
              payload.answer_description &&
              (item.option_description !== null ||
                item.option_description !== "") &&
              !item.answer_value
            ) {
              // this.answer_question = parseInt(this.answer_question) + 1;
            } else {
              if (!item.option_description && item.answer_value) {
                // this.answer_question = parseInt(this.answer_question) + 1;
              }
              if (!item.option_description) {
                let items = item.options.filter((x) => x.selected == true);
                if (items.length == 1) {
                  // this.answer_question = parseInt(this.answer_question) + 1;
                }
              }
            }
          }
          if (payload.selected == 0) {
            if (payload.answer_description == "" && !item.answer_value) {
              // this.answer_question = parseInt(this.answer_question) - 1;
            } else if (payload.answer_value == "") {
              // this.answer_question = parseInt(this.answer_question) - 1;
            } else {
              let items = item.options.filter((x) => x.selected == false);
              if (item.options.length == items.length) {
                item.answer_value = null;
                // this.answer_question = parseInt(this.answer_question) - 1;
              }
            }
          }
          // item.loader = false
          // item.typing = false
        }

        return true;
      } catch (error) {
        item.option_description = "";
        item.answer_value = "";
        item.answer_description = "";
        if (item.options.length > 0) {
          item.answer_value = "";
          item.options.map((x) => (x.selected = false));
        }

        this.$generateError(error);
        return false;
      } finally {
        item.loader = false;
        item.typing = false;
      }
    },
    generateActiveClass(item, option) {
      const oldSelectedId = pathOr(null, ["answer_value"], item);
      const newSelectedId = pathOr(null, ["option_number"], option);

      let status = false;
      item.options.map((optionItem) => {
        optionItem.activeClass = "SquareNotActive";
        const optionValue = pathOr(null, ["option_number"], optionItem);
        const optionSelect = newSelectedId || oldSelectedId;
        if (oldSelectedId !== newSelectedId && optionValue <= optionSelect) {
          optionItem.activeClass = "SquareActive";
          status = true;
        }
      });
      return status;
    },
    async answerQuestioncheckbox(item, option, itemId) {
      if (option.selected) {
        item.answer_description = null;
      }

      /* guidance: handle class for every option */
      const generateActiveClass = this.generateActiveClass(item, option);
      item.answer_value = generateActiveClass ? option.option_number : null;

      option.selected = !option.selected;
      const payload = {
        answer_value: option.option_number.toString(),
      };

      try {
        const result = await this.answePatch(item.id, payload, item);
        // for single choose
        // سوالهای گزینه ای تشریحی حتما باید تک انتخابی باشند
        if (
          result &&
          (this.exam_pack.allow_multiple_answer === 0 ||
            pathOr(null, ["question_kind", "id"], item) === 4)
        ) {
          if (option.option_number) {
            item.option_description = option.option_description;
            item.options.map((x) => {
              if (x.id !== option.id) {
                x.selected = false;
              }
              return x;
            });
          }
        }

        this.checkedAnswerAllQuestion();
      } catch (error) {
        this.$generateError(error);
      }
    },
    async answerQuestionInput(item) {
      item.loader = true;

      const payload = {
        answer_value: item.answer_value,
      };
      await this.answePatch(item.id, payload, item);
      this.checkedAnswerAllQuestion();
      item.loader = false;
      item.typing = false;
    },
    async answerQuestionTextarea(item) {
      item.loader = true;
      item.option_description = item.answer_description;

      const payload = {
        answer_description: item.answer_description,
      };
      await this.answePatch(item.id, payload, item);
      this.checkedAnswerAllQuestion();
      item.loader = false;
      item.typing = false;
    },
    async answerDelete(item) {
      let payload = {};
      // item.loader = true
      if (item.question_kind && item.question_kind.id == 2) {
        payload.answer_value = "";
        item.answer_value = "";
      } else {
        payload.answer_description = "";
        item.answer_description = "";
      }

      item.typing = false;
      await this.answePatch(item.id, payload, item);
    },
    resetByNavigationButtons() {
      this.resetTimer();
      this.resetTimer2();
      this.currentTime = null;
      this.endTime = null;
    },
    nextPage() {
      if (this.isDisabledNextButton) {
        return this.$notify.warning(this.$lang.answer_all_question);
      }
      this.resetByNavigationButtons();

      const isCurrentExamPackLastPage =
        this.page === this.currentExamPackTotalPages;

      // when go to next exam pack
      if (this.currentExamPackEndedTime || isCurrentExamPackLastPage) {
        const nextExamPackId = this.next;
        if (!nextExamPackId)
          return this.$notify.error(
            this.$lang.azmoonLang.relation_examPack_notExist
          );

        this.currentExamPackEndedTime = false;
        const name = "azmoon_execute_exam_pack";
        const params = {
          id: this.azmoon_execute_id,
          exam_pack_id: nextExamPackId,
        };
        const queryString = getCurrentQueryString();
        goToRoute(name, params, queryString, false);
        this.page = 1;
        localStorage.setItem(this.pageName, this.page);
        this.timer2(false);
      } else {
        // when go to next questions
        this.page += 1;
        localStorage.setItem(this.pageName, this.page);
        this.getQuestions();
      }
    },
    prevPage() {
      this.resetByNavigationButtons();

      const isCurrentExamPackFirstPage = this.page === 1;

      // when go to prev exam pack
      if (
        isCurrentExamPackFirstPage ||
        this.currentExamPackEndedTime ||
        !this.has_questions
      ) {
        const prevExamPackId = this.prev;
        if (!prevExamPackId)
          return this.$notify.error(
            this.$lang.azmoonLang.relation_examPack_notExist
          );

        this.currentExamPackEndedTime = false;
        const name = "azmoon_execute_exam_pack";
        const params = {
          id: this.azmoon_execute_id,
          exam_pack_id: prevExamPackId,
        };
        const queryString = getCurrentQueryString();
        goToRoute(name, params, queryString, false);
        this.page = 1;
        localStorage.setItem(this.pageName, this.page);
        this.timer2(false);
      } else {
        // when go to prev questions
        this.page -= 1;
        localStorage.setItem(this.pageName, this.page);
        this.getQuestions();
      }
    },
    async getQuestions() {
      if (this.currentExamPackEndedTime) return;
      this.isloadingPage = true;
      const storagePage = +localStorage.getItem(this.pageName) || this.page;
      this.question_params = {
        page: storagePage,
        order_by: "question_number:asc",
      };
      try {
        this.isOverlay = true;
        const response_questions =
          await this.azmoonExecuteExamPackQuestionsRepository.list(
            this.azmoon_execute_id,
            this.$route.params.exam_pack_id,
            this.question_params
          );
        this.question_items = response_questions.data.data.result.map(
          (item) => {
            let option_description;
            if (item.question_info.answer_value) {
              let answer_value = item.question_info.answer_value;
              option_description = item.question_info.options[answer_value - 1]
                ? item.question_info.options[answer_value - 1]
                    .option_description
                : "";
            }
            if (item.question_info.answer_description) {
              option_description = item.question_info.answer_description;
            }
            return {
              loader: false,
              ...item.question_info,
              option_description: option_description,
            };
          }
        );

        const data = pathOr(null, ["data", "data"], response_questions);
        const otherData = pathOr(null, ["data", "other"], response_questions);
        this.currentExamPackTotalQuestions = pathOr(null, ["total"], data);
        this.page = pathOr(1, ["current_page"], data);
        this.per_page = pathOr(null, ["per_page"], data);
        this.currentExamPackTotalPages = pathOr(1, ["total_pages"], data);
        this.endTime = pathOr(null, ["end_time"], otherData);
        this.currentTime = pathOr(null, ["current_time"], otherData);
        this.timer(this.currentTime, this.endTime);
        this.checkedAnswerAllQuestion();
        if (this.exam_pack.is_repeat_description == 0 && this.page == 1) {
          //  0 == نمایش نده
          this.is_repeat_description = true;
        }
        if (this.exam_pack.is_repeat_description == 0 && this.page == 2) {
          //  0 == نمایش نده
          this.is_repeat_description = false;
        }
        this.count_question = data.count;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isOverlay = false;
        this.isloadingPage = false;
      }
    },
    checkedAnswerAllQuestion() {
      const isAnswerToAllQuestion = pathOr(
        0,
        ["is_answer_to_all_question"],
        this.exam_pack
      );
      if (isAnswerToAllQuestion) {
        this.answeredAllQuestions =
          this.answer_question === this.currentExamPackTotalQuestions;
      } else {
        this.answeredAllQuestions = true;
      }
    },
    async fetchData() {
      try {
        this.exam_pack_id = this.$route.params.exam_pack_id;
        this.isLoading = true;
        let url_run =
          this.$config.api_url +
          this.$config.azmoon.azmoon_execute_exam_pack_run
            .replace("{0}", this.$route.params.id)
            .replace("{1}", this.$route.params.exam_pack_id);
        const response = await this.$httpService.get(url_run);
        let data = response.data.data;
        this.callback_url = data.callback_url;
        this.exam_pack = data.exam_pack;
        this.next = data.next;
        this.prev = data.prev;
        this.term_state_code = data.term_state_code;
        this.is_only_one_answer = data.is_only_one_answer;
        this.has_questions = data.has_questions;
        this.azmoon_execute_person = data.azmoon_execute_person;
        this.answer_question = data.answer_count;
        localStorage.setItem("answer_question", data.answer_count);
        this.total_answer_count = pathOr(0, ["total_answer_count"], data);
        this.total_question_count = pathOr(0, ["total_question_count"], data);
        this.is_show_as_form = pathOr(
          0,
          ["exam_pack", "is_show_as_form"],
          data
        );

        const otherData = pathOr(null, ["data", "other"], response);
        this.endTime = pathOr(null, ["end_time"], otherData);
        this.currentTime = pathOr(null, ["current_time"], otherData);
        this.timer(this.currentTime, this.endTime);

        if (this.has_questions) {
          await this.getQuestions();
        } else {
          this.question_items = [];
          this.currentExamPackTotalPages = 1;
        }

        if (this.exam_pack.is_repeat_description == 0 && this.page == 1) {
          //  0 == نمایش نده
          this.is_repeat_description = true;
        }
        if (this.exam_pack.is_repeat_description == 0 && this.page > 1) {
          //  0 == نمایش نده
          this.is_repeat_description = false;
        }
        if (this.exam_pack.is_repeat_description == 1) {
          //  0 == نمایش نده
          this.is_repeat_description = true;
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    resetTimer() {
      this.counter = "00:00:00";
      clearInterval(this.timerQueue);
    },
    resetTimer2() {
      this.counter2 = 10;
      clearInterval(this.timerQueue2);
    },
    timer(getCurrentTime, getEndTime) {
      this.resetTimer();
      if (!getCurrentTime || !getEndTime) return;
      const currentTime = new Date(getCurrentTime).getTime();
      const endTime = new Date(getEndTime).getTime();
      let distance = endTime - currentTime;
      this.currentExamPackEndedTime = distance <= 0 ? true : false;

      clearInterval(this.timerQueue);
      this.timerQueue = setInterval(() => {
        distance = distance - 1000;
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        hours = hours > 0 ? hours : 0;
        minutes = minutes > 0 ? minutes : 0;
        hours = hours >= 10 ? hours : `0${hours}`;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        seconds = seconds >= 10 ? seconds : `0${seconds}`;
        this.counter = `${hours}:${minutes}:${seconds}`;
        if (distance < 0) {
          this.resetTimer();
          this.currentExamPackEndedTime = true;
        }
      }, 1000);
    },
    timer2(redirect = true) {
      if (!this.next) return;
      let distance = 10;
      clearInterval(this.timerQueue2);
      this.timerQueue2 = setInterval(() => {
        distance--;
        this.counter2 = distance;
        if (distance <= 0) {
          this.resetTimer2();
          if (redirect) {
            this.nextPage();
          }
        }
      }, 1000);
    },
    checkLineOption(item, examPack) {
      const examPackDispleyModeId = pathOr(
        null,
        ["display_mode", "id"],
        examPack
      );
      const questionDispleyModeId = pathOr(null, ["display_mode", "id"], item);
      const itemQuestionKindId = pathOr(null, ["question_kind", "id"], item);
      const con1 =
        examPackDispleyModeId === 2 && includes(itemQuestionKindId, [1, 4]);
      const con2 =
        examPackDispleyModeId === null &&
        questionDispleyModeId === 2 &&
        includes(itemQuestionKindId, [1, 4]);
      return con1 || con2;
    },
    goToBackUrl() {
      const queryString = getCurrentQueryString();
      const referrerUrl = pathOr(null, ["referrer"], queryString);
      setTimeout(() => {
        if (referrerUrl) {
          window.open(referrerUrl, "_self");
        } else {
          window.close();
        }
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.line-hr {
  height: 4px;
  background: #1b1919;
}

.card-question_black {
  border: 1px solid black !important;

  .card-body {
    padding: 5px 25px !important;
  }

  .card-header {
    padding: 5px !important;
    margin-bottom: 0;
    background-color: #ffffff !important;
  }
}

figure > img {
  width: 100%;
}

// .image{
//   margin: 0!important;
// }
.title_description {
  p {
    padding: 0px 3px;
    margin: 0px !important;
    margin-bottom: 0px !important;
  }
}

/* new  */

.loading-center {
  background: #a1a1a1b3;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.h-100vh {
  height: 80vh;
}

figure.table {
  width: 100% !important;
}

.m-3-5 {
  margin: 30px 5px;
}

.checkAnswer {
  position: absolute;
  left: 1px;
  top: 1px;
}

.count_question {
  background-color: #4c4ce6;
  padding: 10px;
  color: white;
  border-radius: 7px;
  width: 100%;
  text-align: center;
}

.color-answer {
  background-color: red;
  border-radius: 4px;
  padding: 2px 8px;
  margin-left: 5px;
  display: inline-block;
}

.ul-exam {
  display: inline-flex;
  margin: 0;
  list-style: none;
  padding: 0;

  li {
    padding: 0 15px;
  }
}

@media (max-width: 767px) {
  .ul-exam {
    display: block;
  }

  .count_question {
    width: 100%;
  }
}

.messageNot {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.fixed-header {
  position: fixed;
  top: 0;
  z-index: 1;
}
</style>
